import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography, Grid, List, ListItem, ListItemText } from "@mui/material";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { socketConnection } from "../../services/socket";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = localStorage.getItem("companyId");
    const socket = socketConnection({ companyId });

    socket.on(`company-${companyId}-whatsappSession`, (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === "update" && data.session.qrcode === "") {
        onClose();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [whatsAppId, onClose]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" scroll="paper">
      <Paper elevation={3} style={{ padding: 24, width: 750, margin: "auto" }}>
        <Grid container spacing={1} sx={{
          alignItems: "center"
        }}>
 
          <Grid size={6}>
            <Typography variant="h6" color="primary" gutterBottom>
              Conecta tu cuenta de WhatsApp
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="1. Abre WhatsApp en tu teléfono." />
              </ListItem>
              <ListItem>
                <ListItemText primary="2. Ve a Configuración > Dispositivos Vinculados." />
              </ListItem>
              <ListItem>
                <ListItemText primary="3. Toca 'Vincular un dispositivo'." />
              </ListItem>
              <ListItem>
                <ListItemText primary="4. Escanea el código QR con tu cámara." />
              </ListItem>
            </List>
          </Grid>

          {}
          <Grid style={{ textAlign: "center" }} size={6}>
            {qrCode ? (
              <QRCode value={qrCode} size={220} />
            ) : (
              <Typography variant="body1" color="textSecondary">
                Esperando código QR...
              </Typography>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
